import React, {useState} from 'react'
import _ from 'lodash'
import {
    Grid
} from '@material-ui/core'
import {useDispatch} from 'react-redux'
import { useIntl } from 'src/common/razzle-platform-translate'
import {email, min, required} from 'src/common/razzle-platform-components/form-validators'
import {useAlert} from 'src/common/razzle-platform-components/alert'
import {Form} from 'src/common/razzle-platform-components/form-fields'
import {DefaultCheckBoxField, DefaultPasswordField, DefaultSubmitButton, DefaultTextField} from 'src/common/razzle-platform-user/Authentication/components/defaultFields'
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'
import { checkRight } from 'src/common/razzle-platform-user/helpers'


const LoginForm = (props) => {

    const [isLoginInProgress, setLoginInProgress] = useState(false)
    const dispatch = useDispatch()
    const { actions, closeAuthenticationDialog, displayAuthorization } = useAuth()
    const {errorAlert} = useAlert()
    const { formatMessage } = useIntl()

    const { checkBoxField, passwordField, submitButton, textField } = props

    const handleSubmit = async (data) => {
        try {
            setLoginInProgress(true)
            const user = await dispatch.userModel.login({data})
            setLoginInProgress(false)
            if (actions.executeAfterLogin && _.isFunction(actions.executeAfterLogin)) {
                if (actions.authorization) {
                    if (!actions.authorization.requiredRight) throw new Error('"requiredRight" value is not valid')
                    const hasAccessRight = checkRight(user.rights, actions.authorization.requiredRight)
                    if (hasAccessRight) {
                        closeAuthenticationDialog()
                        actions.executeAfterLogin(user)
                    } else {
                        displayAuthorization()
                    }
                } else {
                    closeAuthenticationDialog()
                    actions.executeAfterLogin(user)
                }
            }
        } catch (error) {
            errorAlert(error)
            setLoginInProgress(false)
        }
    }

    const TextField = textField || DefaultTextField
    const PasswordField = passwordField || DefaultPasswordField
    const CheckBoxField = checkBoxField || DefaultCheckBoxField
    const SubmitButton = submitButton || DefaultSubmitButton

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container={true} spacing={4}>
                <Grid item={true} xs={12}>
                    <TextField
                        inProgress={isLoginInProgress}
                        type="email"
                        name="email"
                        label={formatMessage({ id: 'Email', defaultMessage: 'Email' })}
                        validate={[required(), email()]}
                        required
                    />
                </Grid>
                <Grid item={true} xs={12}>
                    <PasswordField
                        inProgress={isLoginInProgress}
                        name="password"
                        label={formatMessage({ id: 'Mot de passe', defaultMessage: 'Mot de passe' })}
                        required
                        // @ts-ignore
                        validate={[required(), min(6, formatMessage({id: 'Le mot de passe doit contenir au moins 6 caractères', defaultMessage: 'Le mot de passe doit contenir au moins 6 caractères'}))]}
                    />
                </Grid>

                <Grid item={true} xs={12} style={{paddingTop: 0}}>
                    <CheckBoxField
                        name="remember_me"
                        label={formatMessage({ id: 'Maintenir la connexion', defaultMessage: 'Maintenir la connexion' })}
                        inProgress={isLoginInProgress}
                    />
                </Grid>
                <Grid container={true} item={true} xs={12} direction="row" justify="center" style={{marginTop: 5}}>
                    <Grid item={true} xs={8}>
                        <SubmitButton inProgress={isLoginInProgress} label={formatMessage({ id: 'Connexion', defaultMessage: 'Connexion' })} />
                    </Grid>
                </Grid>

            </Grid>
        </Form>
    )

}

export default LoginForm
